/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from '../util/prop_types';
import { SidePanelSelectors } from '../stores/sidepanel_selectors';
import { SidePanelActionCreators } from '../stores/sidepanel_action_creators';
import { ViewSelectors } from '../stores/view_selectors';
import OmniboxSuggestionItem from './omnibox_suggestion_item';

const mapStateToProps = (state) => {
  return {
    activeId: SidePanelSelectors.getActiveId(state),
    searchSuggestions: ViewSelectors.getSearchSuggestions(state),
  }
}

const mapDispatchToProps = {
  setSuggestionResults: SidePanelActionCreators.setSuggestionResults,
}

class OmniboxSuggestions extends React.Component {
  static propTypes = {
    activeId: PropTypes.number.isRequired,
    searchSuggestions: PropTypes.immutable.list.isRequired,
    onKeyUp: PropTypes.func.isRequired,
  }

  render(): ?React.Element<any> {
    var suggestions = this.props.searchSuggestions.map((suggestion, i) => {
      const selectionHandler = () => {
        this.props.setSuggestionResults(suggestion.get('name'),
          suggestion.getIn(['dataset', 'ownerId']),
          suggestion.getIn(['dataset', 'datasetId']));
      };
      return (
        <OmniboxSuggestionItem
          isActive={(i+1 == this.props.activeId)}
          key={suggestion.get('key')}
          icon={suggestion.get('icon')}
          name={suggestion.get('name')}
          onSelection={selectionHandler} />
      );
    });

    return (
      <ul id="search-suggestions"
        role="listbox"
        onKeyUp={this.props.onKeyUp}>
        {suggestions}
      </ul>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OmniboxSuggestions);
